var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var HomePageService = /** @class */ (function () {
    function HomePageService() {
    }
    /**
     * 获取当日新增案件
     */
    HomePageService.prototype.getTodayInsertCaseCount = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getTodayInsertCaseCount,
            data: data
        });
    };
    /**
     * 催收案件数量统计
     */
    HomePageService.prototype.getCollectionCaseCount = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getCollectionCaseCount,
            data: data
        });
    };
    /**
     * 流出案件数量统计
     */
    HomePageService.prototype.getOutCaseCount = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getOutCaseCount,
            data: data
        });
    };
    /**
     * 行动代码监控
     */
    HomePageService.prototype.actionCodeMonitor = function (overduePeriod) {
        return this.netService.send({
            server: domainService.homePageController.actionCodeMonitor,
            data: {
                overduePeriod: overduePeriod
            }
        });
    };
    /*
     * 获取催收员案件量
     */
    HomePageService.prototype.getHomeCaseTotal = function () {
        return this.netService.send({
            server: domainService.homePageController.getHomeCaseTotal,
        });
    };
    /**
     * 催收员回款排行
     */
    HomePageService.prototype.getCollectorRackIngData = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getCollectorRackIngData,
            data: data
        });
    };
    /**
     * 案件总数
     */
    HomePageService.prototype.getAllCaseCount = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getAllCaseCount,
            data: data
        });
    };
    /**
     * 车库车辆
     */
    HomePageService.prototype.getAllWarehouseCar = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getAllWarehouseCar,
            data: data
        });
    };
    // 排名
    HomePageService.prototype.getCollectionRanking = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getCollectionRanking,
            data: data
        });
    };
    /**
     * 待催收案件
     */
    HomePageService.prototype.getWaitCollectCaseChart = function () {
        return this.netService.send({
            server: domainService.homePageController.getWaitCollectCaseChart
        });
    };
    /**
     * 流出案件
     */
    HomePageService.prototype.getOutCaseChart = function () {
        return this.netService.send({
            server: domainService.homePageController.getOutCaseChart
        });
    };
    /**
     * 回款统计
     */
    HomePageService.prototype.getRepaymentChart = function (data) {
        return this.netService.send({
            server: domainService.homePageController.getRepaymentChart,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], HomePageService.prototype, "netService", void 0);
    return HomePageService;
}());
export { HomePageService };
